import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { PlatformFeature, ProductSectorDetail } from 'api'
import { DataGrid, filteredColumnDefsBuilder, GridId } from 'view/components/datagrid'
import { productSectorDetailsSelector } from 'selectors/productSelectors'
import { SectorColumnDefs, SectorGridColumnId, sectorGridOptions } from './SectorGridModel'
import { createPlatformFeatureEnabledSelector } from 'selectors/platformSelectors'

interface SectorGridProps {
  sectorList: ProductSectorDetail[]
  platformStartConsiderationOverrideEnabled: boolean
}

const mapStateToProps = createStructuredSelector({
  sectorList: productSectorDetailsSelector,
  platformStartConsiderationOverrideEnabled: createPlatformFeatureEnabledSelector(PlatformFeature.ENABLE_START_CONSIDERATION_OVERRIDE)
})

export const SectorGridComponent: React.FunctionComponent<SectorGridProps> = ({
  sectorList,
  platformStartConsiderationOverrideEnabled
}) => {
  const filteredColumnDefs = useMemo(
    () =>
      filteredColumnDefsBuilder(SectorColumnDefs)
        .withoutIf(!platformStartConsiderationOverrideEnabled, [SectorGridColumnId.SECTOR_START_CONSIDERATION_OVERRIDE_THRESHOLD])
        .build(),
    [platformStartConsiderationOverrideEnabled]
  )

  return (
    <DataGrid
      gridId={GridId.AdminSectorGrid}
      gridOptions={sectorGridOptions}
      disableGrouping={true}
      rowData={sectorList}
      columnDefs={filteredColumnDefs}
    />
  )
}

export const SectorGrid = connect(mapStateToProps)(SectorGridComponent)
